<template>
  <div class="row justify-content-center align-items-md-center">
    <div class="col-md-11">
      <div class="card full-height bg-ligth">
        <!-- <div class="card-body"> -->
        <div class="row card-body form-group">
          <div class="form-group col-md-5">
            <label class="col-md-12">Buscar por nombre</label>
            <input required type="text" class="form-control" v-model="filtro.nome" />
          </div>

          <div class="form-group col-md-4">
            <label class="col-md-12">Tipo de Examen: </label>
            <treeselect v-model="filtro.tipo_examen_id" :multiple="false" :options="lista_tipo_exames" />
          </div>
          <div class="col-md-3 justify-content-end row mt-8">
            <div class="ml-1">
              <button class="btn btn-success" @click="pesquisar()">
                <i class="fa fa-search search-icon m-0 p-0"></i>
              </button>
            </div>
            <div class="ml-1">
              <button class="btn btn-info" @click="gerarExcel()">
                <i class="fa fa-print m-0 p-0"></i>
              </button>
            </div>
            <!-- <div class="ml-1">
              <button class="btn btn-primary" @click="media()">
                <i class="fa fa-print m-0 p-0"></i>
              </button>
            </div> -->
            <!-- </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-11 pt-3">
      <div class="card full-height bg-ligth">
        <!-- <div class="card-header">
          <h3 class="mb-0">Salidas de Productos General</h3>
        </div> -->
        <div class="card-body">
          <b-table :fields="[
            'nome',
            'codigo',
            'status',
            'tipo_exame',
            'tipo_amostra',
            'preco',
            'status',
            'acoes',
          ]" :items="lista_exames" :per-page="perPage" :current-page="currentPage" id="saida_produto"
            class="table table-head-custom table-vertical-center table-head-bg table-borderless"
            show-empty empty-text="Nenhum registro encontrado!">
            <template #head(acoes)><span></span></template>
            <template #head(preco)><span>Precio</span></template>
            <template #cell(preco)="{ item }">{{ fomatarGuarani(item.preco) }}</template>
            <template #cell(acoes)="{ item }">
              <div class="text-right w-100">
                <button v-show="lista_permissoes_filial.u_Exame" @click="atualizar(item)"
                  class="btn btn-icon btn-light btn-sm mx-1" v-b-tooltip.hover title="Editar registro">
                  <i class="far fa-edit text-primary"></i>
                </button>


                <button v-show="lista_permissoes_filial.lock_Exame" @click="confirm(item.id, item.status)"
                  class="btn btn-icon btn-light btn-sm mx-1" v-b-tooltip.hover title="Activar/Inactivar registro">
                  <i v-if="item.status == 2" class="fas fa-unlock-alt text-info"></i>
                  <i v-else="item.status == 2" class="fas fa-lock text-info"></i>
                </button>

                <button v-show="lista_permissoes_filial.d_Exame" @click="confirm(item.id, 0)"
                  class="btn btn-icon btn-light btn-sm mx-1" v-b-tooltip.hover title="Excluir registro">
                  <i class="far fa-trash-alt text-danger"></i>
                </button>
              </div>
            </template>
            <template #cell(status)="{ item }"><span></span>
              <span style="font-size: 12px" class="label label-lg label-inline" :class="{
                'label-light-success': item.status === 1,
                'label-light-warning': item.status === 2,
                'label-light-error': item.status === 0,
              }">
                {{
                  item.status === 1
                    ? "Activo"
                    : item.status === 2
                      ? "Inactivo"
                      : "eliminado"
                }}
              </span>
            </template>
          </b-table>
          <b-pagination v-model="currentPage" :total-rows="atendimentos.length" :per-page="perPage"
            aria-controls="saida_produto">
          </b-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/store/breadcrumbs.module";
import { fireAlert } from "@/core/mixins/alertMessageMixin";
export default {
  mixins: { fireAlert },
  data() {
    return {
      currentPage: 2,
      perPage: 10,
      filtro: {
        nome: null,
        tipo_examen_id: null,
      },
      nome_pesquisa: null,
      atendimentos: [],
    };
  },
  watch: {
    nome_pesquisa() {
      if (this.nome_pesquisa.length >= 3) {
        this.filtro.nome = this.nome_pesquisa
        this.pesquisar()
      }
    },
    'filtro.tipo_examen_id'() {
      this.pesquisar()
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Gerenciar Examenes" },
    ]);
  },
  created() {
    this.listar_exames();
    this.listar_requerimentos();
  },
  computed: {
    lista_exames() {
      return this.$store.state.exame.lista_exames;
    },
    lista_permissoes_filial() {
      return this.$store.state.sistema.lista_permissoes_filial;
    },
    mensagem_alert() {
      return this.$store.state.exame.mensagem_alert;
    },
    lista_tipo_exames() {
      return this.$store.state.tipo_exame.lista_tipo_exames;
    },
    lista_filials() {
      return this.$store.state.configEmpresa.lista_filials;
    },
  },
  methods: {
    async pesquisar() {
      this.$store.dispatch("configEmpresa/MudarPreloader", true);
      await this.$store
        .dispatch("exame/pesquisar_exames", this.filtro)
        .finally(() => {
          this.$store.dispatch("configEmpresa/MudarPreloader", false);
        });
    },
    async listar_requerimentos() {
      await this.$store.dispatch("tipo_exame/listar_tipo_exames_ativos");
    },
    async listar_exames() {
      await this.$store.dispatch("exame/listar_exames");
    },
    async gerarExcel() {
      await this.$store.dispatch(
        "exame/gerar_excel",
        this.filtro
      );
    },


    atualizar(value) {
      this.$store.dispatch("configEmpresa/atualizar", value);
      this.$router.push({ name: "createExame" });

    },
    async confirm(value, status) {
      let acao = 'desactiva'
      if (status == 2) acao = 'activa'
      if (status == 0) acao = 'exclui'
      await this.$confirm({
        title: "Estas seguro?",
        message: 'Esta ação ' + acao + ' el Examen.',
        button: {
          no: "No",
          yes: "Si",
        },
        callback: (confirm) => {
          if (confirm) {
            if (status == 1) this.bloquear(value);
            if (status == 2) this.desbloquear(value);
            if (status == 0) this.exclui(value);
          }
        },
      });
    },
    async bloquear(value) {
      await this.$store.dispatch("exame/bloquear_exame", value);
     
      this.alertMessage(this.mensagem_alert.tipo, this.mensagem_alert.message);
      await this.pesquisar()
    },
    async desbloquear(value) {
      await this.$store.dispatch("exame/desbloquear_exame", value);
      this.alertMessage(this.mensagem_alert.tipo, this.mensagem_alert.message);
      await this.pesquisar()
    },
    async exclui(value) {
      await this.$store.dispatch("exame/delete_exame", value);
      this.alertMessage(this.mensagem_alert.tipo, this.mensagem_alert.message);
      await this.pesquisar()
    },
    alertMessage(tipo, mensagem) {
      console.log(this.alertMessage)
      this.$fire({
        title: "Aviso",
        text: mensagem,
        type: tipo,
        timer: 3000,
      }).then((r) => {
        console.log(r.value);
      });
    },

    fomatarGuarani(valor) {
      // const input = valor.replace(/[^\d]/g, ""); // remove tudo que não for número
      const value = Number.parseInt(valor, 10);
      const formatted = new Intl.NumberFormat("es-PY", {
        style: "currency",
        currency: "PYG",
        currencyDisplay: "symbol",
      }).format(value);
      return formatted;
    },
    
  },
};
</script>

<style scoped>
.lista:hover {
  background-color: rgba(167, 183, 255, 0.705);
}
</style>